import React, { useState, useRef, useEffect } from "react";

const METALLIC_COLORS = [
    { name: "Metallic Gold", hex: "#D4AF37", gradient: "linear-gradient(135deg, #bf953f 0%, #fcf6ba 25%, #b38728 50%, #fbf5b7 75%, #aa771c 100%)" },
    { name: "Metallic Silver", hex: "#BCC6CC", gradient: "linear-gradient(135deg, #9c9c9c 0%, #f1f1f1 50%, #c0c0c0 100%)" },
    { name: "Rose Gold", hex: "#B76E79", gradient: "linear-gradient(135deg, #b76e79 0%, #f3d1d6 50%, #9e505c 100%)" },
    { name: "Bronze", hex: "#CD7F32", gradient: "linear-gradient(135deg, #8f5d38 0%, #dfbfa1 50%, #a87c53 100%)" },
    { name: "Copper", hex: "#B87333", gradient: "linear-gradient(135deg, #8a4f1c 0%, #f0c2a2 50%, #b87333 100%)" },
    { name: "Champagne", hex: "#F7E7CE", gradient: "linear-gradient(135deg, #e3ceab 0%, #fff6e6 50%, #f7e7ce 100%)" }
];

const SPECIAL_COLORS = [
    { name: "Multicolour", hex: "#FFFFFF" }
];

const WHITE_SHADES = [
    { name: "White", hex: "#FFFFFF" },
    { name: "Off White", hex: "#FAF9F6" },
    { name: "Clear", hex: "#F8F8FF" },
    { name: "Ivory", hex: "#FFFFF0" },
    { name: "Cream", hex: "#FFFDD0" },
    { name: "Beige", hex: "#F5F5DC" },
    { name: "Pearl", hex: "#EAE0C8" }
];

const PALETTE_COLUMNS = [
    {
        name: "Neutral",
        colors: [
            { name: "White", hex: "#FFFFFF" },
            { name: "Off White", hex: "#FAF9F6" },
            { name: "Clear", hex: "#F8F8FF" },
            { name: "Transparent", hex: "#FFFFFF00" }
        ]
    },
    {
        name: "Dark Shades",
        colors: [
            { name: "Light Grey", hex: "#D3D3D3" },
            { name: "Silver", hex: "#C0C0C0" },
            { name: "Grey", hex: "#808080" },
            { name: "Charcoal", hex: "#36454F" },
            { name: "Dark Grey", hex: "#404040" },
            { name: "Gunmetal", hex: "#2A3439" },
            { name: "Matte Black", hex: "#171717" },
            { name: "Black", hex: "#000000" }
        ]
    },
    {
        name: "Cream / Brown",
        colors: [
            { name: "Ivory", hex: "#FFFFF0" },
            { name: "Cream", hex: "#FFFDD0" },
            { name: "Beige", hex: "#F5F5DC" },
            { name: "Pearl", hex: "#EAE0C8" },
            { name: "Sand", hex: "#C2B280" },
            { name: "Khaki", hex: "#F0E68C" },
            { name: "Tan", hex: "#D2B48C" },
            { name: "Camel", hex: "#C19A6B" },
            { name: "Brown", hex: "#8B4513" },
            { name: "Chocolate", hex: "#7B3F00" },
            { name: "Dark Brown", hex: "#5C4033" }
        ]
    },
    {
        name: "Earth",
        colors: [
            { name: "Terracotta", hex: "#E2725B" },
            { name: "Rust", hex: "#B7410E" },
            { name: "Mahogany", hex: "#C04000" },
            { name: "Walnut", hex: "#773F1A" }
        ]
    },
    {
        name: "Red",
        colors: [
            { name: "Coral Red", hex: "#FF4040" },
            { name: "Red", hex: "#FF0000" },
            { name: "Cherry", hex: "#DE3163" },
            { name: "Crimson", hex: "#DC143C" },
            { name: "Burgundy", hex: "#800020" },
            { name: "Maroon", hex: "#800000" },
            { name: "Wine", hex: "#722F37" },
            { name: "Dark Red", hex: "#8B0000" },
            { name: "Plum", hex: "#673147" }
        ]
    },
    {
        name: "Pink",
        colors: [
            { name: "Peach", hex: "#FFE5B4" },
            { name: "Apricot", hex: "#FBCEB1" },
            { name: "Baby Pink", hex: "#F4C2C2" },
            { name: "Light Pink", hex: "#FFB6C1" },
            { name: "Pink", hex: "#FFC0CB" },
            { name: "Salmon", hex: "#FA8072" },
            { name: "Blush", hex: "#DE5D83" },
            { name: "Rose", hex: "#FF007F" },
            { name: "Ruby", hex: "#E0115F" },
            { name: "Dusty Rose", hex: "#C08081" },
            { name: "Hot Pink", hex: "#FF69B4" }
        ]
    },
    {
        name: "Yellow / Orange",
        colors: [
            { name: "Light Yellow", hex: "#FFFFE0" },
            { name: "Lemon", hex: "#FFF700" },
            { name: "Yellow", hex: "#FFFF00" },
            { name: "Golden Yellow", hex: "#FFDF00" },
            { name: "Gold", hex: "#FFD700" },
            { name: "Mustard", hex: "#FFDB58" },
            { name: "Amber", hex: "#FFBF00" },
            { name: "Orange", hex: "#FFA500" },
            { name: "Tangerine", hex: "#F28500" },
            { name: "Dark Orange", hex: "#FF8C00" },
            { name: "Burnt Orange", hex: "#CC5500" }
        ]
    },
    {
        name: "Green",
        colors: [
            { name: "Mint", hex: "#98FF98" },
            { name: "Light Green", hex: "#90EE90" },
            { name: "Pista", hex: "#93C572" },
            { name: "Sage", hex: "#9CAF88" },
            { name: "Lime", hex: "#00FF00" },
            { name: "Neon Green", hex: "#39FF14" },
            { name: "Kelly Green", hex: "#4CBB17" },
            { name: "Emerald", hex: "#50C878" },
            { name: "Jade", hex: "#00A86B" },
            { name: "Green", hex: "#008000" },
            { name: "Dark Green", hex: "#006400" }
        ]
    },
    {
        name: "Teal / Sea",
        colors: [
            { name: "Aqua", hex: "#00FFFF" },
            { name: "Turquoise", hex: "#40E0D0" },
            { name: "Sea Green", hex: "#2E8B57" },
            { name: "Teal", hex: "#008080" },
            { name: "Bottle Green", hex: "#006A4E" },
            { name: "Dark Teal", hex: "#014D4E" },
            { name: "Forest Green", hex: "#228B22" },
            { name: "Olive", hex: "#808000" },
            { name: "Smoke", hex: "#738276" },
            { name: "Graphite", hex: "#383838" }
        ]
    },
    {
        name: "Blue",
        colors: [
            { name: "Powder Blue", hex: "#B0E0E6" },
            { name: "Baby Blue", hex: "#89CFF0" },
            { name: "Sky Blue", hex: "#87CEEB" },
            { name: "Steel Blue", hex: "#4682B4" },
            { name: "Royal Blue", hex: "#4169E1" },
            { name: "Denim", hex: "#1560BD" },
            { name: "Cobalt", hex: "#0047AB" },
            { name: "Blue", hex: "#0000FF" },
            { name: "Dark Blue", hex: "#00008B" },
            { name: "Navy Blue", hex: "#000080" },
            { name: "Indigo", hex: "#4B0082" }
        ]
    },
    {
        name: "Purple",
        colors: [
            { name: "Lavender", hex: "#E6E6FA" },
            { name: "Lilac", hex: "#C8A2C8" },
            { name: "Mauve", hex: "#E0B0FF" },
            { name: "Orchid", hex: "#DA70D6" },
            { name: "Magenta", hex: "#FF00FF" },
            { name: "Violet", hex: "#8F00FF" },
            { name: "Purple", hex: "#800080" },
            { name: "Coffee", hex: "#6F4E37" },
            { name: "Taupe", hex: "#483C32" }
        ]
    },
    {
        name: "Special",
        colors: [
            { name: "Multicolour", hex: "#FFFFFF" }
        ]
    },
    {
        name: "Metallic Colours",
        colors: [
            { name: "Metallic Gold", hex: "#D4AF37", gradient: "linear-gradient(135deg, #bf953f 0%, #fcf6ba 25%, #b38728 50%, #fbf5b7 75%, #aa771c 100%)" },
            { name: "Metallic Silver", hex: "#BCC6CC", gradient: "linear-gradient(135deg, #9c9c9c 0%, #f1f1f1 50%, #c0c0c0 100%)" },
            { name: "Rose Gold", hex: "#B76E79", gradient: "linear-gradient(135deg, #b76e79 0%, #f3d1d6 50%, #9e505c 100%)" },
            { name: "Bronze", hex: "#CD7F32", gradient: "linear-gradient(135deg, #8f5d38 0%, #dfbfa1 50%, #a87c53 100%)" },
            { name: "Copper", hex: "#B87333", gradient: "linear-gradient(135deg, #8a4f1c 0%, #f0c2a2 50%, #b87333 100%)" },
            { name: "Champagne", hex: "#F7E7CE", gradient: "linear-gradient(135deg, #e3ceab 0%, #fff6e6 50%, #f7e7ce 100%)" }
        ]
    }
];

const getColorTabName = (name, hex) => {
    if (hex && hex.toUpperCase().startsWith("TAB:")) {
        return hex.replace(/tab:/i, "");
    }
    const upperHex = hex ? hex.toUpperCase() : "";
    const lowerName = name ? name.toLowerCase() : "";

    // 1. Check PALETTE_COLUMNS first to match exact columns
    for (const col of PALETTE_COLUMNS) {
        if (col.colors.some(c => 
            (upperHex && c.hex.toUpperCase() === upperHex) || 
            (lowerName && c.name.toLowerCase() === lowerName)
        )) {
            return col.name;
        }
    }

    // 2. Check Metallic Colours
    const isMetallic = METALLIC_COLORS.some(m => 
        (upperHex && m.hex.toUpperCase() === upperHex) || 
        (lowerName && m.name.toLowerCase() === lowerName)
    );
    if (isMetallic) return "Metallic Colours";

    // 3. Check Special
    const isSpecial = SPECIAL_COLORS.some(s => 
        (upperHex && s.hex.toUpperCase() === upperHex) || 
        (lowerName && s.name.toLowerCase() === lowerName)
    );
    if (isSpecial) return "Special";

    // 4. Fallback based on name matching
    if (lowerName) {
        if (lowerName.includes("gold") || lowerName.includes("silver") || lowerName.includes("bronze") || lowerName.includes("copper") || lowerName.includes("champagne") || lowerName.includes("metallic")) {
            return "Metallic Colours";
        }
        if (lowerName.includes("multicolour") || lowerName.includes("multicolor")) {
            return "Special";
        }
        if (lowerName.includes("white") || lowerName.includes("clear") || lowerName.includes("transparent")) {
            return "Neutral";
        }
        for (const col of PALETTE_COLUMNS) {
            const firstWord = col.name.split(" ")[0].toLowerCase();
            if (lowerName.includes(firstWord)) {
                return col.name;
            }
        }
    }

    return "Neutral"; // Fallback
};

// Helper to find color details by hex
const getColorDetails = (hex) => {
    if (!hex) return null;
    
    const upperHex = hex.toUpperCase();
    if (upperHex.startsWith("TAB:")) {
        const tabName = hex.replace("tab:", "");
        return { name: `${tabName} Tab`, hex: hex };
    }

    if (upperHex === "#FFFFFF00" || hex.toLowerCase() === "transparent") {
        return { name: "Transparent", hex: "#FFFFFF00" };
    }
    
    // Check metallic colors
    const metallic = METALLIC_COLORS.find(m => m.hex.toUpperCase() === upperHex);
    if (metallic) return metallic;

    for (const col of PALETTE_COLUMNS) {
        for (const c of col.colors) {
            if (c.hex.toUpperCase() === upperHex) {
                return c;
            }
        }
    }
    return { name: "Custom Color", hex };
};

const ColorPalettePicker = ({ value, onChange, name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("common"); // "common", "special", "metallic"
    const [hoveredColor, setHoveredColor] = useState(null);
    const containerRef = useRef(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelectColor = (color) => {
        onChange({
            target: {
                name,
                value: color.hex
            }
        });
        setIsOpen(false);
    };

    const handleSelectTab = (tabName) => {
        onChange({
            target: {
                name,
                value: `tab:${tabName}`
            }
        });
        setIsOpen(false);
    };

    const currentColor = getColorDetails(value) || { name: "Select Color", hex: value || "#000000" };

    const getBackgroundStyle = (color) => {
        if (!color) return "#ccc";
        if (color.hex && color.hex.startsWith("tab:")) {
            const tabName = color.hex.replace("tab:", "");
            const col = PALETTE_COLUMNS.find(c => c.name === tabName);
            if (col && col.colors && col.colors.length > 0) {
                // Return a gradient of the first 4 colors of the tab
                const colorsHex = col.colors.slice(0, 4).map(c => c.hex);
                const filtered = colorsHex.filter((h, idx) => h !== "#FFFFFF00" && colorsHex.indexOf(h) === idx);
                if (filtered.length > 1) {
                    return `linear-gradient(135deg, ${filtered.join(", ")})`;
                } else if (filtered.length === 1) {
                    return filtered[0];
                }
            }
            return "#ccc";
        }
        if (color.gradient) {
            return color.gradient;
        }
        if (color.name === "Transparent") {
            return "repeating-linear-gradient(45deg, #e0e0e0, #e0e0e0 4px, #ffffff 4px, #ffffff 8px)";
        }
        if (color.name === "Multicolour") {
            return "linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)";
        }
        // Check if it's one of our metallic colors
        const metallic = METALLIC_COLORS.find(m => m.name === color.name);
        if (metallic) {
            return metallic.gradient;
        }
        return color.hex;
    };

    return (
        <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
            {/* Custom styled trigger button */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="form-control d-flex align-items-center justify-content-between ms-2"
                style={{
                    width: "75px",
                    padding: "0.2rem 0.4rem",
                    cursor: "pointer",
                    height: "38px",
                    border: "1px solid #cccccc",
                    borderRadius: "4px",
                    background: "#ffffff"
                }}
                title={currentColor.name}
            >
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "3px",
                        background: getBackgroundStyle(currentColor),
                        border: "1px solid rgba(0,0,0,0.15)"
                    }}
                />
                <span style={{ fontSize: "10px", color: "#666", marginLeft: "2px" }}>▼</span>
            </button>

            {/* Dropdown Popover */}
            {isOpen && (
                <div
                    className="animation_fade"
                    style={{
                        position: "absolute",
                        top: "105%",
                        right: 0,
                        zIndex: 9999,
                        background: "#ffffff",
                        border: "1px solid #d3d3d3",
                        borderRadius: "8px",
                        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
                        padding: "12px",
                        width: "620px"
                    }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(13, 1fr)",
                            gap: "3px",
                            backgroundColor: "#f5f5f5",
                            padding: "4px",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0"
                        }}
                    >
                        {/* Headers */}
                        {PALETTE_COLUMNS.map((col) => (
                            <button
                                key={col.name}
                                type="button"
                                onClick={() => handleSelectTab(col.name)}
                                style={{
                                    background: "#2c2c2c",
                                    color: "#ffffff",
                                    fontSize: "9px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    padding: "4px 2px",
                                    borderRadius: "3px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    textTransform: "uppercase",
                                    border: "none",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                                title={`Select ${col.name} Tab`}
                                onMouseEnter={() => setHoveredColor({ name: `${col.name} Tab`, hex: `tab:${col.name}`, column: col.name })}
                                onMouseLeave={() => setHoveredColor(null)}
                            >
                                {col.name.split(" ")[0]}
                            </button>
                        ))}

                        {/* Swatches */}
                        {Array.from({ length: 11 }).map((_, rowIndex) => (
                            <React.Fragment key={rowIndex}>
                                {PALETTE_COLUMNS.map((col) => {
                                    const color = col.colors[rowIndex];
                                    if (!color) {
                                        return (
                                            <div
                                                key={`${col.name}-${rowIndex}`}
                                                style={{
                                                    width: "100%",
                                                    height: "26px",
                                                    background: "transparent",
                                                    border: "none",
                                                    borderRadius: "3px"
                                                }}
                                            />
                                        );
                                    }
                                    const isSelected = value && value.toUpperCase() === color.hex.toUpperCase() && 
                                        (color.name !== "Transparent" || value === "#FFFFFF00") &&
                                        !value.startsWith("tab:");
                                    return (
                                        <button
                                            key={`${col.name}-${rowIndex}`}
                                            type="button"
                                            onClick={() => handleSelectColor(color)}
                                            onMouseEnter={() => setHoveredColor({ ...color, column: col.name })}
                                            onMouseLeave={() => setHoveredColor(null)}
                                            style={{
                                                width: "100%",
                                                height: "26px",
                                                background: getBackgroundStyle(color),
                                                border: isSelected ? "2px solid #000000" : "1px solid rgba(0,0,0,0.15)",
                                                borderRadius: "3px",
                                                cursor: "pointer",
                                                padding: 0,
                                                outline: "none",
                                                transform: isSelected ? "scale(1.05)" : "none",
                                                boxShadow: isSelected ? "0 0 4px rgba(0,0,0,0.3)" : "none"
                                            }}
                                            title={`${color.name} (${color.hex})`}
                                        />
                                    );
                                })}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Preview Footer */}
                    <div
                        style={{
                            marginTop: "12px",
                            padding: "8px 12px",
                            background: "#f9f9f9",
                            borderRadius: "6px",
                            border: "1px solid #eaeaea",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "12px",
                            height: "40px"
                        }}
                    >
                        {hoveredColor ? (
                            <>
                                <div
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "4px",
                                        background: getBackgroundStyle(hoveredColor),
                                        border: "1px solid rgba(0,0,0,0.15)",
                                        marginRight: "10px"
                                    }}
                                />
                                <div>
                                    <span style={{ fontWeight: "bold", color: "#222" }}>{hoveredColor.name}</span>
                                    <span style={{ color: "#666", marginLeft: "8px", fontFamily: "monospace" }}>{hoveredColor.hex}</span>
                                    <span style={{ color: "#888", marginLeft: "8px", fontSize: "10px", textTransform: "uppercase", background: "#eaeaea", padding: "2px 6px", borderRadius: "10px" }}>
                                        {hoveredColor.column}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <>
                                <div
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "4px",
                                        background: getBackgroundStyle(currentColor),
                                        border: "1px solid rgba(0,0,0,0.15)",
                                        marginRight: "10px"
                                    }}
                                />
                                <div>
                                    <span style={{ color: "#666" }}>Selected: </span>
                                    <span style={{ fontWeight: "bold", color: "#222" }}>{currentColor.name}</span>
                                    <span style={{ color: "#666", marginLeft: "8px", fontFamily: "monospace" }}>{currentColor.hex}</span>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export const getSwatchColorCode = (colorVal, dynamicPalettes = []) => {
    if (!colorVal) return "transparent";

    let name = "";
    let directCode = "";
    if (typeof colorVal === "object" && colorVal !== null) {
        name = colorVal.name || colorVal.color || "";
        directCode = colorVal.colorCode || colorVal.hex || "";
    } else {
        name = String(colorVal).trim();
    }

    if (directCode && (directCode.startsWith("#") || directCode.startsWith("rgb") || directCode.startsWith("linear-gradient"))) {
        return directCode;
    }

    if (name.startsWith("#") || name.startsWith("rgb") || name.startsWith("linear-gradient")) {
        return name;
    }

    const lowerName = name.toLowerCase().trim();
    const cleanName = lowerName.replace(/[\s-_]/g, "");

    if (lowerName === "transparent") return "transparent";
    if (lowerName === "multicolour" || lowerName === "multicolor") {
        return "linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)";
    }

    // 1. Check METALLIC_COLORS
    const metallic = METALLIC_COLORS.find(m => 
        m.name.toLowerCase() === lowerName || 
        m.name.toLowerCase().replace(/[\s-_]/g, "") === cleanName
    );
    if (metallic) return metallic.gradient || metallic.hex;

    // 2. Check SPECIAL_COLORS
    const special = SPECIAL_COLORS.find(s => 
        s.name.toLowerCase() === lowerName || 
        s.name.toLowerCase().replace(/[\s-_]/g, "") === cleanName
    );
    if (special) return special.hex;

    // 3. Check WHITE_SHADES
    const white = WHITE_SHADES.find(w => 
        w.name.toLowerCase() === lowerName || 
        w.name.toLowerCase().replace(/[\s-_]/g, "") === cleanName
    );
    if (white) return white.hex;

    // 4. Check PALETTE_COLUMNS
    for (const col of PALETTE_COLUMNS) {
        if (col.colors) {
            const found = col.colors.find(c => 
                c.name.toLowerCase() === lowerName || 
                c.name.toLowerCase().replace(/[\s-_]/g, "") === cleanName
            );
            if (found) return found.gradient || found.hex;
        }
    }

    // 5. Check dynamic color palettes
    if (Array.isArray(dynamicPalettes)) {
        for (const pal of dynamicPalettes) {
            if (pal.colors) {
                const found = pal.colors.find(c => 
                    c.name.toLowerCase() === lowerName || 
                    c.name.toLowerCase().replace(/[\s-_]/g, "") === cleanName
                );
                if (found) return found.gradient || found.hex || found.colorCode;
            }
        }
    }

    // 6. Common fallback map
    const fallbackMap = {
        rose: '#FF007F',
        neongreen: '#39FF14',
        gold: '#FFD700',
        silver: '#C0C0C0',
        nude: '#E3BC9A',
        beige: '#F5F5DC',
        ivory: '#FFFFF0',
        coral: '#FF6B6B',
        peach: '#FFCBA4',
        lavender: '#E6E6FA',
        mint: '#98FF98',
        teal: '#008080',
        mustard: '#FFDB58',
        olive: '#808000',
        rust: '#B7410E',
        burgundy: '#800020',
        champagne: '#F7E7CE',
        charcoal: '#36454F',
        offwhite: '#FAF9F6',
        pistagreen: '#93C572',
        pista: '#93C572',
        wine: '#722F37',
        ruby: '#E0115F',
        dustyrose: '#C08081',
        hotpink: '#FF69B4',
        crimson: '#DC143C',
        maroon: '#800000',
        aqua: '#00FFFF',
        turquoise: '#40E0D0',
        emerald: '#50C878',
        chocolate: '#7B3F00',
        coffee: '#6F4E37',
        denim: '#1560BD',
        indigo: '#4B0082',
        magenta: '#FF00FF',
        violet: '#8F00FF',
        plum: '#673147',
        gunmetal: '#2A3439',
        matteblack: '#171717'
    };

    if (fallbackMap[cleanName]) {
        return fallbackMap[cleanName];
    }

    return lowerName;
};

export const getColorDotStyle = (colorVal, dynamicPalettes = []) => {
    const code = getSwatchColorCode(colorVal, dynamicPalettes);
    const lower = String(typeof colorVal === "object" && colorVal !== null ? colorVal.name || "" : colorVal).toLowerCase().trim();

    if (lower === "transparent") {
        return {
            backgroundColor: "transparent",
            backgroundImage: "repeating-conic-gradient(#ccc 0% 25%, white 0% 50%) 50% / 100% 100%",
            border: "1px solid rgba(0,0,0,0.2)"
        };
    }

    if (code.startsWith("linear-gradient") || code.startsWith("repeating-linear-gradient")) {
        return {
            background: code,
            border: "1px solid rgba(0,0,0,0.15)"
        };
    }

    return {
        backgroundColor: code,
        border: "1px solid rgba(0,0,0,0.15)"
    };
};

export { PALETTE_COLUMNS, METALLIC_COLORS, SPECIAL_COLORS, WHITE_SHADES, getColorTabName };
export default ColorPalettePicker;

